module.exports = __webpack_public_path__ + "src/assets/img/leto.5ae9458d.jpg";